import { captureException } from '@sentry/nextjs'

import fetcher from '../../utils/fetcher'

// Singleton promise to avoid multiple simultaneous network calls
let pendingPromise: Promise<void> | null = null

/**
 * Ensure that the browser has a fresh XSRF-TOKEN cookie.
 * Always resolves, even if the underlying network request fails.
 * Created because in some cases after logging out the CSRF token is not properly re-validated,
 * causing login modal to automatically open, autofilled, and giving 419 when trying to log in.
 */
export default async function ensureCsrfCookie(): Promise<void> {
  if (pendingPromise) {
    return pendingPromise
  }

  const apiUrl = process.env.NEXT_PUBLIC_API_URL
  const url = `${apiUrl}/sanctum/csrf-cookie`

  pendingPromise = fetcher(url, 'GET', undefined, undefined, false)
    .catch((error) => {
      captureException(error)
      // Swallow error so auth flow can continue, but still log.
      console.error('Failed to refresh CSRF cookie', error)
    })
    .then(() => {
      pendingPromise = null
    })

  return pendingPromise
}
